// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export default css`
  display: flex;
  flex: 1;
  padding-top: 6px;
  padding-bottom: 13px;
  padding-left: 1px;
  background-color: ${(props) =>
    props.noBackground ? 'none' : props.theme.colors.PRIMARY.PALEGRAY};
  img {
    height: 13px;
    width: 13px;
    padding: 3px 13px 0 6px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: ${(props) => (props.fromLoginFlow ? '3px 13px 0 8px' : '3px 13px 0 6px')};
    }
  }
  ${(props) => (props.customClass ? props.customClass : '')};

  .warning-icon {
    background: transparent url('${(props) => getIconPath('error-message-icon', props)}') no-repeat
      0 0;
    background-size: contain;
    flex-shrink: 0;
    border: none;
    height: ${(props) => (props.fromLoginFlow ? '26px' : props.theme.spacing.LAYOUT_SPACING.XXS)};
    width: ${(props) => (props.fromLoginFlow ? '26px' : props.theme.spacing.LAYOUT_SPACING.XXS)};
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
    ${(props) => (props.isAddedToBag ? `margin-left:0` : '')}

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: ${(props) => props.fromLoginFlow && '20px'};
      width: ${(props) => props.fromLoginFlow && '20px'};
      margin-top: ${(props) => props.fromLoginFlow && '0px'};
    }
  }

  .place-cash-error {
    color: ${(props) =>
      props.spc ? props.theme.colors.NOTIFICATION.ERROR : props.theme.colors.TEXT.RED};
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    .click-here {
      color: ${(props) => props.theme.colors.TEXT.RED};
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      padding: 0 2px 0 2px;
    }
  }

  .err-message-container {
    width: ${(props) =>
      props.isCloseable ? `calc(100% - ${props.theme.spacing.ELEM_SPACING.XL})` : '100%'};
    display: inline-flex;
    align-items: flex-start;
    ${(props) => (props.isCloseable && !props.fromLoginFlow ? 'justify-content: center;' : '')}
    ${(props) =>
      props.isAddedToBag
        ? `border-radius:${props.theme.spacing.ELEM_SPACING.XS_6}; padding: ${props.theme.spacing.ELEM_SPACING.MED}; background-color: ${props.theme.colors.NOTIFICATION.ERROR_BACKGROUND};`
        : ''}

    & span {
      font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
      ${(props) => props.fromLoginFlow && `font-size: ${props.theme.typography.fontSizes.fs14};`}
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        ${(props) => props.fromLoginFlow && `font-size: ${props.theme.typography.fontSizes.fs12};`}
      }
    }
  }

  .close-btn {
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 0 ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0
        ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }
  }
  ${(props) =>
    props.spc &&
    `
    background-color: ${props.theme.colors.NOTIFICATION.ERROR_BACKGROUND};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${props.theme.spacing.LAYOUT_SPACING.XXS} ${props.theme.spacing.LAYOUT_SPACING.XXS};
    margin: 0;
    margin-top:${props.isMinibag ? '0' : props.theme.spacing.ELEM_SPACING.XS_6};
    border-radius:${props.theme.spacing.ELEM_SPACING.XS_6};
    @media ${props.theme.mediaQuery.medium} {
      padding: 22px;
    }
    @media ${props.theme.mediaQuery.smallOnly} {
     ${
       props.fromLoginFlow &&
       `border-radius: 0px;     align-items: flex-start;
     `
     }
    }
    @media ${props.theme.mediaQuery.large} {
      .err-message-container{
        margin: 0;
        ${props.fromLoginFlow && `align-items: center;`}
      }
    }
  `}
  ${(props) =>
    props.spc &&
    props.comp === 'zip-comp' &&
    `
    background-color: ${props.theme.colors.NOTIFICATION.ERROR_BACKGROUND};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${props.theme.spacing.LAYOUT_SPACING.XXS} ${props.theme.spacing.LAYOUT_SPACING.XXS};
    margin: 0 13px;
    border-radius: 6px;
    .err-message-container{
      align-items: center;
    }
    @media ${props.theme.mediaQuery.medium} {
      padding: 10px;
    }
    @media ${props.theme.mediaQuery.large} {
      .err-message-container{
        margin: 0 auto;
        width: auto;
      }
    }
  `};
`;
